// extracted by mini-css-extract-plugin
module.exports = {"mainFooter":"Footer_mainFooter__1gYye","footerHead":"Footer_footerHead__1t5-Z","apps":"Footer_apps__2qPVI","infoBox":"Footer_infoBox__1x-D3"};